import React from 'react';
import { Col, Glyphicon, OverlayTrigger, Row, Table } from 'react-bootstrap';
import { ITceFormula } from '@nkr/models/composite-score-dashboard/tce-formula';
import { PopoverWrapper } from '@nkr/views/admin/center/list/saturation-grid/overlays';

interface IProps {
    centerId: number,
    centerAlias: string,
    isPartnerCenter: boolean,
    data: ITceFormula
}

const TceFormula = ({ centerAlias, isPartnerCenter, data }: IProps) => {
    const list = [
        {
            label: <>Partner Center</>,
            centerValue: <span style={{ color: isPartnerCenter ? 'green' : 'red' }}>{isPartnerCenter ? <Glyphicon glyph='ok' /> : <Glyphicon glyph='remove' />}</span>,
            networkValue: data.networkPartnerCenterCount,
            rank: '-'
        },
        {
            label:
                <div style={{ width: 'fit-content' }}>
                    <OverlayTrigger trigger={['hover', 'click']} placement='right' overlay={
                        <PopoverWrapper>
                            <div style={{ marginBottom: 5 }}>The Net Chains Started Score is the difference between Good Samaritan Donations (Family Voucher and NDDs) and chain-end waitlist transplants</div>
                            <ul style={{ paddingInlineStart: 20 }}>
                                <li>
                                    <div><strong>Chain End Waitlist Transplants</strong></div>
                                    <div>This includes waitlist chain-end transplants, kidney replacement cases and broken chain pairs (where the patient receives a transplant, but the donor does not donate)</div>
                                </li>
                                <li>
                                    <div><strong>Qualifying Chain Starting Donations</strong></div>
                                    <div>This includes non-directed donors and family voucher donors (with unredeemed vouchers)</div>
                                </li>
                            </ul>
                        </PopoverWrapper>
                    }>
                        <div style={{ cursor: 'pointer' }}>Net Chains Started (NCS) Score <Glyphicon glyph='info-sign' style={{ color: '#a1a1a1' }} /></div>
                    </OverlayTrigger>
                </div>,
            centerValue: data.centerNcsScore,
            networkValue: data.networkNcsScore,
            rank: '-'
        },
        {
            label:
                <>
                    <div style={{ fontWeight: 550 }}>Composite Scores</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(% of All Composite Scores)</div>
                </>,
            centerValue: isPartnerCenter
                ? <><div>{data.centerCompositeScore}</div><div style={{ fontSize: 12 }}>({data.centerCompositeScorePercent}%)</div></>
                : 'N/A',
            networkValue: <><div>{data.networkCompositeScore}</div><div style={{ fontSize: 12 }}>(100%)</div></>,
            rank: isPartnerCenter ? data.compositeScoreRank : 'N/A'
        },
        {
            label: <span style={{ fontWeight: 550 }}>Forecasted Float for the Network</span>,
            centerValue: data.centerForecastedFloat,
            networkValue: data.networkForecastedFloat,
            rank: '-'
        },
        {
            label:
                <>
                    <div style={{ fontWeight: 550 }}>Share of the Float</div>
                    <div style={{ fontSize: 12, lineHeight: '15px' }}>(Center's Composite Score % Multiplied by the Forecasted Float)</div>
                </>,
            centerValue: data.centerShareOfFloat,
            networkValue: data.networkShareOfFloat,
            rank: '-'
        },
        {
            label:
                <div style={{ width: 'fit-content' }}>
                    <OverlayTrigger trigger={['hover', 'click']} placement='right' overlay={
                        <PopoverWrapper>
                            <div style={{ marginBottom: 5 }}><strong>Hard to Place Donor Add Backs</strong></div>
                            <div style={{ marginBottom: 5 }}>+1 TCE bonus applies to chain end waitlist transplants (excluding internal one-ways) when the accepted donor meets at least one of the following criteria:</div>
                            <ul style={{ paddingInlineStart: 20 }}>
                                <li>Donor age &gt;= 65</li>
                                <li>Left kidney with &gt;= 3 arteries</li>
                                <li>Right kidney with &gt;= 2 arteries</li>
                                <li>Creatinine clearance &lt; 80 ml/min</li>
                                <li>Donor blood type is AB</li>
                            </ul>
                            <div>Real Time Swap Failure acceptances also qualify but are not required to meet the above criteria.</div>
                        </PopoverWrapper>
                    }>
                        <div style={{ cursor: 'pointer' }}>Hard to Place Donor Add Backs <Glyphicon glyph='info-sign' style={{ color: '#a1a1a1' }} /></div>
                    </OverlayTrigger>
                </div>,
            centerValue: data.centerHardToPlaceDonorAddBacks,
            networkValue: data.networkHardToPlaceDonorAddBacks,
            rank: data.hardToPlaceDonorAddBacksRank
        },
        {
            label: <><span style={{ fontWeight: 550 }}>Targeted Chain Ends</span><br /><span style={{ fontSize: 12 }}>(NCS Score + Share of Float + Hard to Place Donor Add Backs)</span></>,
            centerValue: isPartnerCenter ? data.centerTargetedChainEnds : 'N/A',
            networkValue: data.networkTargetedChainEnds,
            rank: isPartnerCenter ? data.targetedChainEndsRank : 'N/A',
            backgroundColor: '#ccc'
        },
    ];

    return (
        <div style={{ paddingTop: 10 }}>
            <Row>
                <Col xs={12} lg={6}>
                    <Table condensed bordered>
                        {/* <thead>
                            <tr style={{ height: 42, backgroundColor: '#A6C9EC' }}>
                                <th style={{ verticalAlign: 'middle' }}>Targeted Chain End (TCE) Formula</th>
                                <th colSpan={3} style={{ textAlign: 'center', verticalAlign: 'middle' }}>{centerAlias}</th>
                            </tr>
                        </thead> */}
                        <thead>
                            <tr>
                                <th></th>
                                <th style={{ minWidth: 100, textAlign: 'center' }}>Your Center</th>
                                <th style={{ textAlign: 'center' }}>Network Totals</th>
                                <th style={{ textAlign: 'center' }}>Rank in Network</th>
                            </tr>
                        </thead>
                        <tbody>
                            {list.map((item, index) =>
                                <tr key={'item-' + index} style={{ height: 42, backgroundColor: item.backgroundColor }}>
                                    <td style={{ paddingLeft: 10, verticalAlign: 'middle' }}>
                                        {item.label}
                                    </td>
                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        {item.centerValue}
                                    </td>
                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        {item.networkValue}
                                    </td>
                                    <td style={{ textAlign: 'center', verticalAlign: 'middle' }}>
                                        {item.rank}
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </div>
    );
}

export default TceFormula;